import React, { useEffect, useState } from 'react';

import { Alert, Divider } from 'antd';

const ALERT_KEY = 'ccb_info_alert_closed';

export default function CcbAlert() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const wasClosed = localStorage.getItem(ALERT_KEY) === 'true';

    if (!wasClosed) {
      setOpen(true);
    }
  }, []);

  const handleClose = () => {
    localStorage.setItem(ALERT_KEY, 'true');
    setOpen(false);
  };

  if (!open) return null;

  return (
    <>
      <Alert
        type='info'
        showIcon
        closable
        onClose={handleClose}
        message='O que é CCB?'
        description='A Cédula de Credito Bancário (CCB) é um documento legal que formaliza o crédito quando você escolhe parcelar sua compra. É como um "comprovante jurídico" do acordo de crédito entre você e a instituição financeira.'
      />
      <Divider />
    </>
  );
}
